import { render, staticRenderFns } from "./RegistrationForm.vue?vue&type=template&id=0eac1856&scoped=true&"
import script from "./RegistrationForm.vue?vue&type=script&lang=ts&setup=true&"
export * from "./RegistrationForm.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./RegistrationForm.vue?vue&type=style&index=0&id=0eac1856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eac1856",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eac1856')) {
      api.createRecord('0eac1856', component.options)
    } else {
      api.reload('0eac1856', component.options)
    }
    module.hot.accept("./RegistrationForm.vue?vue&type=template&id=0eac1856&scoped=true&", function () {
      api.rerender('0eac1856', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/doctors/register/index/DoctorsRegisterContent/components/RegistrationForm/RegistrationForm.vue"
export default component.exports